import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { connect } from "react-redux";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Formatter from "../../../Localization/Formatter";
import Constants from "../../../Action/Constants";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import TextField from "../../Partials/Material/TextField";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import * as ReactTooltip from "react-tooltip";
import Memo from "../../Partials/Memo/Memo";

class Invoices extends Component {
  protected selectedCharge: ChargeInterface;
  protected selectedChargeIndex: number;
  protected searchTimer;
  protected textFieldRef;
  public noteField: null;

  protected paginatorPath: string = `Finance_Charges_${this.props.app.financeChargesFilterState}_${this.props.app.financeChargesFilterDateState}_${this.props.app.financeChargesFilterSearchState}`;

  public state = {
    charges: [],
    filter: "all",
    isChargeRemovePopupOpen: false,
    isSaving: false,
    anchorEl: null,
    hasModifiedData: false,
    openLeavePrompt: false,
    isFetching: true,
    filterValue: "",
    chargesCount: 0,
    dateFilter: null,

    selectedChargesRows: [],
    selectedCharges: [],
    firstDateOfStatementPeriodForPayment: new Date(),
    dateOfThePayment: new Date(),
    searchInProgress: false,
    memoPopupOpen: false,
    note: "",
    chargeToAddNote: null,
    paymentDateQuickOption: new Date(),
    isNewTaskPopupOpen: false,
  };

  protected middlewares: MiddlewareInterface[] = [PreventPageLeave];

  constructor(public props) {
    super(props);
    this.textFieldRef = React.createRef();
  }

  public componentWillMount() {
    this.setState(
      {
        ...this.props.app.financeChargesFilterCheckBoxState,
      },
      () => {
        this.fetchFirstAllCharges(() => {
          window.scrollTo({
            top: this.props.app?.financeChargesListPosition,
          });
        });
      }
    );
  }

  public componentWillUnmount() {
    clearTimeout(this.searchTimer);

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: this.state.filterValue,
      },
    });

    this.props.dispatch({
      type: Constants.GLOBAL_LAUNCH_PANEL_STATE,
      payload: {
        launchPanelState: false,
      },
    });
  }

  public fetchFirstAllCharges = (callback?) => {
    const paginationAmount =
      !!this.props.app.paginator &&
      !!this.props.app.paginator[this.paginatorPath]
        ? this.props.app.paginator[this.paginatorPath]
        : this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      //hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      invoiceNumber: true,
      agencyOnly: true,
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload,
      },
      onSuccess: (data) => {
        console.log(data.charges.filter(charge => charge.invoiceNumber.indexOf('0148') !== -1), 'data.charges');
        this.setState(
          {
            searchInProgress: false,
            charges: data.charges,
            chargesCount: data.count,
            isFetching: false,
          },
          () => {
            if (typeof callback === "function") {
              callback();
            }
          }
        );
      },
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false,
        });
      },
    });
  };

  public fetchFilterAllCharges = () => {
    const payload: any = {
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      //hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      invoiceNumber: true,
      agencyOnly: true,
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload,
      },
      onSuccess: (data) => {
        this.setState({
          charges: data.charges,
          chargesCount: data.count,
        });
      },
    });
  };

  public clearFilterAllCharges = () => {
    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: "",
      },
    });

    this.setState(
      {
        filterValue: "",
      },
      this.fetchFirstAllCharges
    );

    this.textFieldRef.current.focus();
  };

  public setFilterValue = (event): any => {
    clearTimeout(this.searchTimer);

    this.setState(
      {
        filterValue: event.target.value,
      },
      () => {
        if (this.state.filterValue === "") {
          this.clearFilterAllCharges();
        }

        this.searchTimer = setTimeout(() => {
          this.setState(
            {
              searchInProgress: true,
            },
            () => {
              this.paginatorPath = `Finance_Charges_${this.state.filter}_${this.state.dateFilter}_${this.state.filterValue}`;

              this.props.dispatch({
                type: Constants.FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE,
                payload: {
                  filter: this.state.filterValue,
                },
              });

              this.fetchFirstAllCharges();
            }
          );
        }, this.props.app?.listSearchTimeout);
      }
    );
  };

  public fetchCharges = () => {
    const payload: any = {
      firstItem: !!this.state.charges ? this.state.charges.length : 0,
      lastItem: !!this.state.charges
        ? this.state.charges.length + this.props.app.defaultPaginationAmount
        : 0,
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      //hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      invoiceNumber: true,
      agencyOnly: true,
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload,
      },
      onSuccess: (data) => {
        const chargesArr: ChargeInterface[] = !!this.state.charges
          ? [...this.state.charges, ...data.charges]
          : [...data.charges];

        this.setState({
          charges: chargesArr,
          chargesCount: data.count,
        });
      },
    });
  };

  public selectDate = (momentDate: any, identifier: string): any => {
    const date =
      !!momentDate && typeof momentDate.toDate === "function"
        ? momentDate.toDate()
        : momentDate;

    if (
      !date &&
      (identifier === "firstDateOfStatementPeriodForPayment" ||
        identifier === "dateOfThePayment" ||
        identifier === "paymentDateQuickOption")
    ) {
      return;
    }

    this.setState(
      {
        [identifier]: date,
        hasModifiedData: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.FINANCE_CHARGES_FILTER_DATE_UPDATE_STATE,
          payload: {
            filter: this.state.dateFilter,
          },
        });

        this.fetchFirstAllCharges();
      }
    );
  };

  public getFilteredCharges = (): ChargeInterface[] => {
    return this.state.charges.filter(
      (charge: ChargeInterface) => charge.removed === false
    );
  };

  protected openMenu = (
    event: any,
    charge: ChargeInterface,
    index: number
  ): void => {
    this.selectedCharge = charge;
    this.selectedChargeIndex = index;

    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null,
    });
  };

  public saveScrollPosition = () => {
    var top = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_LIST_POSITION_SAVE,
      payload: {
        position: top,
      },
    });
  };

  public openMemoPopup = (charge: ChargeInterface) => {
    this.setState({
      chargeToAddNote: charge,
      note: charge?.note,
      memoPopupOpen: true,
      anchorEl: null,
    });
  };

  public getCharges = (
    charges: ChargeInterface[],
    selectedChargesRows: number[],
    _callback: any
  ): any => {
    return charges.map((charge: ChargeInterface, index: number) => {
      if (!charge) {
        return;
      }

      const shouldShowPaidDate = !!charge.oldestPaymentDate;
      let chargeDetails;

      if (charge && charge.description === "") {
        chargeDetails = `${
          Formatter.monthYearFormatDate(charge.firstDate)
            ? `${Formatter.monthYearFormatDate(charge.firstDate)},`
            : ""
        } ${Formatter.checkTranslationType(
          this.trans(charge?.type?.label, {}, "", charge?.type?.system),
          charge?.type?.label,
          charge?.type?.system
        )} ${
          !!charge.relatedEntity ? " - " + charge.relatedEntity.displayName : ""
        }`;
      } else {
        chargeDetails = `${
          Formatter.monthYearFormatDate(charge.firstDate)
            ? `${Formatter.monthYearFormatDate(charge.firstDate)},`
            : ""
        } ${charge.description} ${
          !!charge.relatedEntity ? " - " + charge.relatedEntity.displayName : ""
        }`;
      }

      const isItemSelected = selectedChargesRows.includes(index);
      // const labelId = `enhanced-table-checkbox-${index}`;

      return (
        <TableRow
          hover
          key={`charge-${charge.id}`}
          className={`clickable-entity`}
          onClick={() => {
            this.saveScrollPosition();

            return this.redirect(`/app/charge/update/${charge.id}`);
          }}
          role="checkbox"
          aria-checked={isItemSelected}
          selected={isItemSelected}
        >
          {/* <TableCell
              padding="checkbox"
              onClick={event => {event.preventDefault(); event.stopPropagation(); callback(event, [index])}}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell> */}

          <TableCell
            style={{
              width: "24px",
              paddingLeft: "10px",
              paddingRight: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "4px",
              }}
            >
              <div
                style={{ color: charge.getIconColor() }}
                className="icon icon-ic-charge"
              ></div>
            </div>
          </TableCell>

          <TableCell style={{ width: "15%" }}>
            {shouldShowPaidDate && (
              <div style={{ display: "inline-flex", flexDirection: "column" }}>
                <span>{this.formatter.formatDate(charge.invoiceDate)}</span>
                {/* <span style={{ fontSize: "12px", color: "gray" }}>{`${this.trans("status-paid").toLowerCase()}: ${this.formatter.formatDate(charge.oldestPaymentDate)}`}</span> */}
              </div>
            )}
            {!shouldShowPaidDate && (
              <span>{this.formatter.formatDate(charge.invoiceDate)}</span>
            )}
          </TableCell>

          <TableCell style={{ width: "15%" }}>
            <div style={{ display: "inline-flex", flexDirection: "column" }}>
              <span> {charge?.invoiceNumber}</span>
            </div>
          </TableCell>

          <TableCell style={{ width: "50%" }}>
            <div style={{ display: "inline-flex", flexDirection: "column" }}>
              <div style={{ display: "flex", justifyContent: "flex-start" }}>
                {charge?.name || ""}
                {charge.creationTypeDisplayName && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "2px 0px 0px 5px",
                    }}
                  >
                    <div className="list-label creation-type-label">
                      {charge.creationTypeDisplayName}
                    </div>
                  </div>
                )}
              </div>
              <span style={{ fontSize: "12px", color: "gray" }}>
                {chargeDetails}
              </span>
            </div>
          </TableCell>
          <TableCell style={{ width: "10%" }}>
            {this.renderChargeMemoIcon(charge)}
          </TableCell>
          <TableCell style={{ textAlign: "right", width: "20%" }}>
            {
              <div style={{ display: "inline-flex", flexDirection: "column" }}>
                <span>
                  {charge.chargeClass.id ==
                    ChargeClassContainer.pickIdFromLabel("Payable") &&
                    charge?.amount > 0 && (
                      <span className="minus-style">{"-"}</span>
                    )}
                  {this.formatter.formatNumber(charge.amount, charge.currency)}
                </span>
                {this.renderChargeAmountHint(charge)}
              </div>
            }
          </TableCell>
          <TableCell
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div>
              <IconButton onClick={(e) => this.openMenu(e, charge, index)}>
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorEl}
                open={
                  Boolean(this.state.anchorEl) &&
                  this.selectedCharge &&
                  this.selectedCharge.id === charge.id
                }
                onClose={this.closeMenu}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  onClick={() => {
                    return this.redirect(
                      `/app/charge/update/${this.selectedCharge.id}`
                    );
                  }}
                >
                  <ListItemIcon>
                    <div className="icon icon-ic-edit icon-color"></div>
                  </ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>

                {/* <MenuItem
                    key={`add-task-btn`}
                    onClick={() => {
                      this.setState({
                        isNewTaskPopupOpen: true,
                        anchorEl: null
                      })
                    }
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-task icon-style-launch-panel"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                  </MenuItem> */}

                <MenuItem
                  key={`add-memo-btn`}
                  onClick={() => this.openMemoPopup(this.selectedCharge)}
                >
                  <ListItemIcon>
                    <div className="icon icon-ic-memo aligned"></div>
                  </ListItemIcon>
                  <ListItemText>
                    {this.trans("menuitem-open-memo")}
                  </ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  };

  public selectUnselectCharge = (
    row: number,
    selectedCharge: ChargeInterface
  ) => {
    if (selectedCharge.amountRemaining === 0 && selectedCharge.amount !== 0) {
      return;
    }

    if (this.state.selectedChargesRows.includes(row)) {
      const selectedChargesRows = this.state.selectedChargesRows.filter(
        (rowId) => rowId !== row
      );
      const selectedCharges = this.state.selectedCharges.filter(
        (charge) => charge.id !== selectedCharge.id
      );

      this.setState({
        selectedChargesRows: selectedChargesRows,
        selectedCharges: selectedCharges,
      });
    } else {
      if (
        this.state.selectedChargesRows.length ===
        this.props.app?.chargesPaymentsLinkedLimitNumber
      ) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              "section/charge-info/cannottselectchargemaxchargenumberselected",
              { amount: this.props.app?.chargesPaymentsLinkedLimitNumber }
            ),
            type: "warning",
          },
        });
      }

      this.setState(
        {
          selectedChargesRows: [...this.state.selectedChargesRows, row],
          selectedCharges: [...this.state.selectedCharges, selectedCharge],
        },
        () => {
          if (this.state.selectedCharges.length > 0) {
            this.setState({
              hasModifiedData: true,
            });
          }
        }
      );
    }
  };

  public onChargeRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const charge: ChargeInterface = this.state.charges.filter(
      (charge: ChargeInterface) => charge.removed === false
    )[row];

    this.selectUnselectCharge(row, charge);
  };
  public saveDraft = (message) => {
    this.setState({
      note: message,
    });
  };

  public saveReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: this.state.note },
          updateMemo: true,
        },
        onSuccess: () => {
          this.fetchFirstAllCharges();

          this.setState({
            isSaving: false,
            memoPopupOpen: false,
          });
        },
        onError: () => {
          this.setState({ isSaving: false });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("memo-can-not-be-updated"),
              type: "warning",
            },
          });
        },
      });
    });
  };

  public removeReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: "" },
          removeMemo: true,
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          this.fetchFirstAllCharges();

          this.setState({ isSaving: false, memoPopupOpen: false });
        },
        onError: () => {
          this.setState({ isSaving: false });
        },
      });
    });
  };

  public renderChargeMemoIcon = (charge: ChargeInterface) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span>
          <span data-tip={this.getTipText(charge?.note)}>
            <div
              className={`icon ${
                charge?.hasMemos
                  ? "icon-ic-bookmark blue-onhover"
                  : "icon-ic-memo"
              }`}
              onClick={(e) => {
                e.stopPropagation();
                this.openMemoPopup(charge);
              }}
            ></div>
          </span>
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  };

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
      return;
    }

    if (
      0 < charge?.amountRemaining &&
      charge?.amountRemaining < charge?.amount &&
      charge?.isPayable
    ) {
      status = `${this.formatter.formatNumber(
        charge.amountRemaining,
        charge.currency
      )} ${this.trans("status-still-to-pay")}`;
    } else if (
      0 < charge?.amountRemaining &&
      charge?.amountRemaining < charge?.amount &&
      charge?.isReceivable
    ) {
      status = `${this.formatter.formatNumber(
        charge.amountRemaining,
        charge.currency
      )} ${this.trans("status-still-to-receive")}`;
    } else if (
      charge?.amountRemaining === charge?.amount &&
      charge?.isPayable &&
      !charge.isFullyPaid()
    ) {
      status = `${this.trans("status-to-pay")}`;
    } else if (
      charge?.amountRemaining === charge?.amount &&
      charge?.isReceivable &&
      !charge.isFullyPaid()
    ) {
      status = `${this.trans("status-to-receive")}`;
    } else if (charge.isFullyPaid() && charge?.isReceivable) {
      status = `${this.trans("status-received")}`;
    } else if (charge.isFullyPaid() && charge?.isPayable) {
      status = `${this.trans("status-amount/paid")}`;
    } else {
      status = "";
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091",
        }}
      >
        {status}
      </span>
    );
  };

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  };

  public render() {
    return (
      <div className="state-app">
        <div
          className={`box box-full component-finance full-width has-general-page-header with-tabs ${
            this.props.app?.settings?.user?.launchPanelState
              ? "with-launchpanel"
              : ""
          }`}
        >
          <div className="component-header no-paddings">
            <h1>{this.trans("title-invoices")}</h1>
            <TabsComponent activeTab={5} {...this.props} />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div
                className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                <h3 className="card-title">{this.trans("title-invoices")}</h3>
              </div>

              <div>
                <div>
                  {this.state.selectedChargesRows.length === 0 && (
                    <div className="list-filters-wrapper">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <DatePickerComponent
                          {...this.props}
                          id="filterDate"
                          name="filterDate"
                          className="scroll-to-filterDate filter-date-list"
                          label={this.trans(
                            "finance-invoice-filter/date-label/fromdate"
                          )}
                          initialDate={this.state.dateFilter}
                          onChange={(date) =>
                            this.selectDate(date, "dateFilter")
                          }
                          clearButton={true}
                          error={this.getErrorFor("filterDate")}
                          width="200px"
                        />
                      </div>

                      <div className="table-filterer">
                        <TextField
                          autoComplete="off"
                          type="text"
                          style={{ color: "rgb(0, 188, 212)" }}
                          label={this.trans("label-search")}
                          value={this.state.filterValue}
                          onChange={this.setFilterValue}
                          variant="standard"
                          error={false}
                          inputRef={this.textFieldRef}
                        />
                        {this.state.filterValue !== "" && (
                          <div
                            className="icon icon-ic-close clear-button clear-button-search"
                            onClick={this.clearFilterAllCharges}
                          ></div>
                        )}
                        {this.state.searchInProgress && (
                          <div className="search-loader">
                            <CircularProgress size={20} />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator,
                  }}
                  className="listing-table finance-charges-table with-first-border"
                  rows={this.getCharges(
                    this.getFilteredCharges(),
                    this.state.selectedChargesRows,
                    this.onChargeRowSelection
                  )}
                  rowsLength={this.state.chargesCount}
                  subtitle={this.trans("title-no-invoices-to-list")}
                  fetch={this.fetchCharges}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue?.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo
                {...this.props}
                entity={this.state.chargeToAddNote}
                saveDraft={this.saveDraft}
                relations={{ chargeId: this.state.chargeToAddNote?.id }}
                fetchEntities={() => {
                  this.props.dispatch({
                    type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS,
                  });

                  this.fetchFirstAllCharges();
                  this.fetchFilterAllCharges();
                }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.chargeToAddNote)}
          hideCross={true}
          subtitle={
            this.state.chargeToAddNote && this.state.chargeToAddNote.displayName
              ? this.state.chargeToAddNote.displayName
              : ""
          }
        />

        <CreateTaskDialog
          {...this.props}
          entity={this.selectedCharge}
          isOpen={this.state.isNewTaskPopupOpen}
          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false,
              anchorEl: null,
            });
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    charges: state.charges,
    globalTypes: state.globalTypes,
    component: state.payCharges,
  };
};

export default connect(mapStateToProps)(Invoices);
